import React from 'react';

const PurposeAndStory = () => (
    <div id="purpose-and-story">
      <h4 className="text-center font-weight-bold section-title section-title-purpose-and-story">
        Purpose & Story – #MooreIsBetter
      </h4>
      <div className="row">
        <div className="col-md-8 purpose-and-story-text">
          <p>
            Moore Benefit Resources is a premier next-generation employee benefits consulting
            firm that was born with a realization that every company, school district, and
            township across the country is a healthcare company whether they like or not.
          </p>
          <p>
            The product cost too much and cost shifting through higher deductibles and
            premiums can no longer be the answer.
          </p>
          <p>
            Employers and their employees deserve an advisor willing to fight for them and
            their employees.
          </p>
          <p>
            Our team has been trained at some of the most prominent and prestigious
            consulting firms in the industry and we didn’t like what we saw.
          </p>
          <p>
            The status quo is not good enough for us or our clients. We want to show
            everyone that Moore is better!
          </p>
        </div>
      </div>
    </div>
);

export default PurposeAndStory;



// WEBPACK FOOTER //
// ./src/components/PurposeAndStory.js